// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__1P9_m","column":"style_column__IakYM","row":"style_row__17rJv"};